import type { ContextMenuItem } from '../../types/generic';
import type { TabType } from '../../types/tab';

interface Props {
    menuItem: ContextMenuItem;
    contextMenuId: string;
    closeContextMenu: () => void;
    tabType: TabType;
}

const MenuItem = ({ menuItem, contextMenuId, closeContextMenu, tabType }: Props) => {
    const { caption, clickAction } = menuItem;

    const onClickHandler = () => {
        closeContextMenu();
        clickAction({
            targetId: contextMenuId,
            tabType: tabType,
        });
    };

    return (
        <button
            type="button"
            className="context-menu-item"
            onClick={onClickHandler}
            data-testid="context-button"
        >
            <div>{caption}</div>
        </button>
    );
};

export default MenuItem;
